import React from 'react';

export default function CdipSmartPrep() {
  return (
    <div className="bg-slate-950 text-slate-100 min-h-screen py-12 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
      
      {/* Ambient background glow */}
      <div className="absolute top-10 left-1/2 -translate-x-1/2 w-[600px] h-[300px] bg-blue-600/10 blur-[130px] rounded-full pointer-events-none"></div>

      <div className="max-w-5xl mx-auto space-y-12 relative z-10">
        
        {/* Two-Column Hero Header */}
        <div className="bg-slate-900 rounded-3xl p-8 sm:p-12 border border-slate-800 shadow-2xl grid md:grid-cols-2 gap-8 items-center">
          <div className="space-y-6">
            
            {/* CDIP Smart Prep Logo */}
            <div className="w-20 h-20 rounded-2xl bg-slate-950 p-2 border border-slate-800 flex items-center justify-center overflow-hidden shadow-inner">
              <img 
                src="/cdip-Logo.png" 
                alt="CDIP Smart Prep Logo" 
                className="w-full h-full object-contain"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'flex';
                }}
              />
              <div className="w-full h-full bg-blue-600 rounded-xl hidden items-center justify-center text-white font-black text-xl">
                C
              </div>
            </div>

            <h1 className="text-3xl sm:text-4xl font-black text-white tracking-tight">CDIP Smart Prep</h1>
            <p className="text-blue-400 font-bold text-sm tracking-wide">Clinical Documentation Integrity Certification Made Simple</p>
            
            <p className="text-slate-400 text-sm leading-relaxed">
              Helping CDI professionals prepare for the AHIMA CDIP examination through comprehensive review questions, coding guidance, and documentation improvement strategies.
            </p>
          </div>

          {/* Banner Mockup Image Container */}
          <div className="h-64 sm:h-80 rounded-2xl bg-slate-950 border border-slate-800 overflow-hidden relative flex items-center justify-center shadow-inner">
            <img 
              src="/cdip-banner.png" 
              alt="CDIP Smart Prep Banner Mockup" 
              className="w-full h-full object-cover"
              onError={(e) => { e.target.style.display = 'none'; }}
            />
          </div>
        </div>

        {/* Subscription Section with Launch Notice */}
        <div className="bg-slate-900 rounded-3xl p-8 sm:p-10 border border-slate-800 text-center shadow-xl">
          <h2 className="text-2xl font-black text-white mb-3">Get Full Access</h2>
          <p className="text-slate-400 text-sm mb-10 max-w-xl mx-auto">
            Unlock the complete library of CDIP practice questions, detailed rationales, and advanced review materials.
          </p>

          <div className="max-w-sm mx-auto bg-blue-950 p-8 rounded-2xl border border-blue-900/50">
            <span className="text-[10px] font-black uppercase bg-blue-600 text-white px-3 py-1 rounded-full">Full Access</span>
            <h3 className="text-2xl font-black text-white mt-3">Premium CDIP Review</h3>
            <p className="text-4xl font-black text-white my-4">$19.99<span className="text-xs font-normal text-blue-300"> /month</span></p>
            <p className="text-xs text-blue-100 mb-6">Full access to all modules, analytics, and updates.</p>
            <button className="w-full bg-white hover:bg-slate-200 text-blue-700 font-bold py-3.5 rounded-xl transition shadow-md">
              Subscribe Now
            </button>
          </div>
          
          {/* Launch Notice Added Below Subscription Box */}
          <div className="mt-12 p-5 rounded-2xl bg-slate-950 border border-slate-800 inline-flex items-center gap-3 text-emerald-400 shadow-inner">
            <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
            <div className="text-left">
              <p className="text-xs font-bold text-white">Mobile Apps Coming Soon!</p>
              <p className="text-[11px] text-emerald-400/90">CDIP Smart Prep will be launching on the App Store and Google Play Store very soon.</p>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}